import { Button, Icon } from "semantic-ui-react";
import React from "react";

export const ChangeButton = (props) => {
  return (
    <Button icon labelPosition={"left"} size={"tiny"} {...props}>
      <Icon name={"exchange"} />
      Alterar
    </Button>
  );
};
